import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";

const ChargeMaster = () => {


const [showForm, setShowForm] = useState(false);
 const [chargeMaster, setChargeMaster] = useState([]);
 const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

 
 const [form, setForm] = useState({
    charge_name: '',
    charge_mrp: '',
  })

  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const handleAddClick = () => {
    setShowForm(true);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append(" charge_name", form. charge_name);
      sendData.append(" charge_mrp", form. charge_mrp);
  


      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-charge-master/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Charge Type Updated Successfully!', 'success');
        setShowForm(false);
        fetchChargeDetail();

        setForm({
          type: '',
           charge_mrp: '',
        
        })
      } catch (err) {
        showToast('Fail To Update Charge Type!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();

      sendData.append(" charge_name", form.charge_name);
      sendData.append(" charge_mrp", form.charge_mrp);
    


      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-charge-master",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Charge Type Added successfully!', 'success');
        setShowForm(false);
           fetchChargeDetail();

        setForm({
          charge_name: '',
           charge_mrp: '',
       
        })
      } catch (err) {
        showToast('Fail to add Charge Type!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }



  };

  const fetchChargeDetail = async () => {

    try {
      const resParty = await axios.get('https://api.skyguard.group/api/fetch-master-charge');


     setChargeMaster(resParty.data);
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {

   fetchChargeDetail();
  }, []);

  const handleEdit = (form) => {

    setForm({
      id: form.id || '',
      charge_name: form.charge_name || '',
       charge_mrp: form. charge_mrp || '',
   
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


    const filterCharge = chargeMaster.filter((tt) => {
    const term = (searchTerm || "").toLowerCase();
    return (
      (tt.charge_name && tt.charge_name.toLowerCase().includes(term)) 
      );
  });

  return (
    <>
      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Master of Charge</h3>



          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

            <div className="mb-2 w-50 w-md-50 pe-md-2">
              <input
                className="form-control w-100"
                list="datalistOptions"
                placeholder="Search by Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <button className="btn btn-success" onClick={handleAddClick}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>


          {showForm && (


            <div className='card p-3 mb-3  w-75 mx-auto'>
              <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.charge_name}
    </span>
  </div>
)}

                <hr />

                <div className='row g-3'>

                  <div className="col-md-6">
                    <label htmlFor='name' className="form-label fw-medium" >Charge Name </label>
                    <input type="text" className="form-control" name="charge_name" placeholder="Enter here..." 
                    value={form.charge_name} onChange={handleInputChange} required />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor='middle' className="form-label fw-medium" >Charge Rate </label>
                    <input type="number" className="form-control" name="charge_mrp" placeholder="Enter here..."
                      value={form.charge_mrp}
                      onChange={handleInputChange}

                    />
                  </div>




                  <div className='gap-2 d-flex justify-content-center mt-4'>



                    <button type="submit" className='btn btn-success w-10'>
                      {isEditMode ? "Update" : "Save"}
                    </button>
                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                      setShowForm(false);
                      setIsEditMode(false);
                      setForm({
                        charge_name: '',
                         charge_mrp: '',
                   
                      })
                    }}>
                      Cancel
                    </button>
                  </div>

                </div>
              </form>
            </div>
          )}




          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                   <th scope='col'>SN</th>
                              <th scope='col'>Action</th>
                 
                  <th scope='col'>Charge Name</th>
                  <th scope='col'>Charge Rate</th>
            
      
                </tr>
              </thead>
              <tbody>
                {filterCharge.map((acc, idx) => (
                <tr key={idx} >
                     <td>{idx + 1}</td>
                    <td>  <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>

               
                  <td> {acc.charge_name} </td>
                  <td> {acc.charge_mrp}  </td>
             
              
                
                </tr>


              ))}
              </tbody>
            </table>
          </div>



        
        </div>
      </div>
    </>
  )
}

export default ChargeMaster